













































































































import "reflect-metadata";
import {
  AudioVideoController,
  DefaultDeviceController,
  ConsoleLogger,
  DeviceController,
  Device
} from "amazon-chime-sdk-js";
import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import { SelectOption } from "@/interfaces/vuetify/selectOption";
import { DeviceSelection } from "@/interfaces/devices/selection";
import {
  Qualities,
  QualityOptions,
  QualityMappings
} from "@/services/chime/qualityMappings";
import { loadDevices } from "@/services/devices/storage";
import { TestSound } from "@/services/chime/testSound";
import VideoPreview from "./VideoPreview.vue";
import DeviceList from "./DeviceList.vue";
import { find } from "lodash";

@Component<DevicesSelector>({
  data() {
    return {
      selectedAudioInput: null,
      selectedVideoInput: null,
      selectedVideoQuality: Qualities.medium,
      selectedAudioOutput: null,
      audioInputDevices: [],
      videoInputDevices: [],
      audioOutputDevices: [],
      noVideo: false,
      isBlurVideo: null,
      loadingDevices: true,
      name: this.userName
    };
  },
  components: {
    VideoPreview,
    DeviceList
  }
})
export default class DevicesSelector extends Vue {
  audioInputDevices!: MediaDeviceInfo[];
  videoInputDevices!: MediaDeviceInfo[];
  audioOutputDevices!: MediaDeviceInfo[];
  @Prop({ required: true }) deviceController!: DeviceController;
  @Prop({ type: Boolean, default: false }) allowNoVideo!: boolean;
  @Prop({ type: Boolean, default: false }) hasBlurVideoFeature!: boolean;
  @Prop() userName!: string;
  name!: string; // internal name for edit
  qualityOptions = QualityOptions;
  loadingDevices = true;
  noVideo!: boolean;
  isBlurVideo?: boolean;

  selectedVideoQuality!: Qualities;
  selectedAudioInput!: MediaDeviceInfo;
  selectedVideoInput!: MediaDeviceInfo;
  selectedAudioOutput!: MediaDeviceInfo;

  @Emit()
  devicesLoaded() {
    this.loadingDevices = false;
    return true;
  }

  @Emit()
  join(): [string, DeviceSelection, boolean] {
    const isBlurVideo =
      this.isBlurVideo != null ? this.isBlurVideo : this.hasBlurVideoFeature;
    return [
      this.name,
      {
        audioInput: this.selectedAudioInput,
        videoInput: this.noVideo ? null : this.selectedVideoInput,
        audioOutput: this.selectedAudioOutput,
        videoQuality: this.selectedVideoQuality
      },
      isBlurVideo
    ];
  }

  testSpeaker() {
    new TestSound(this.selectedAudioOutput?.deviceId);
  }

  get joinButtonText() {
    return this.selectedVideoInput ? "Join" : "Join without video";
  }

  get hasAudioOutputDevices() {
    return Boolean(this.audioOutputDevices?.length);
  }

  get canJoin() {
    // Check what are the minimum requirements for this to work
    return Boolean(this.selectedAudioInput);
  }

  async mounted() {
    let devices;

    const [videoInputs, audioInputs, audioOutputs] = await Promise.all([
      this.deviceController.listVideoInputDevices(),
      this.deviceController.listAudioInputDevices(),
      this.deviceController.listAudioOutputDevices()
    ]);
    this.devicesLoaded();
    // No label means not allowed by browser
    this.videoInputDevices = videoInputs.filter(device => device.label);
    this.audioInputDevices = audioInputs.filter(device => device.label);
    this.audioOutputDevices = audioOutputs.filter(device => device.label);

    // Check if user disallow the capabilities
    if (!this.videoInputDevices.length || !this.audioInputDevices.length) {
      this.showCapabilityStepsDialog();
    }

    // See if the selection process can be skipped
    const storedDevices = await loadDevices();
    // Audio input
    let media;
    if (storedDevices.audioInput) {
      // Try from stored
      media = find(audioInputs, { deviceId: storedDevices.audioInput });
    }
    // Or default
    if (!media) {
      media = find(audioInputs, { deviceId: "default" });
    }
    if (media) {
      this.selectAudioInput(media);
    }
    media = null;
    // Video input
    if (storedDevices.videoInput) {
      // Try from stored
      media = find(videoInputs, { deviceId: storedDevices.videoInput });
    }
    // Or default
    if (!media) {
      media = find(videoInputs, { deviceId: "default" });
    }
    if (media) {
      this.selectVideoInput(media);
    }
    media = null;
    if (storedDevices.audioOutput) {
      // Try from stored
      media = find(audioOutputs, { deviceId: storedDevices.audioOutput });
    }
    // Or default
    if (!media) {
      media = find(audioOutputs, { deviceId: "default" });
    }
    if (media) {
      this.selectAudioOutput(media);
    }
    if (storedDevices.videoQuality) {
      this.selectVideoQuality(storedDevices.videoQuality as Qualities);
    }

    // TODO store a "remember" or "join immediately"
    if (
      storedDevices.audioInput &&
      storedDevices.videoInput &&
      storedDevices.audioOutput
    ) {
      this.join();
    }
    // Otherwise select first items
    if (this.videoInputDevices.length) {
      this.selectedVideoInput = this.videoInputDevices[0];
    }
    if (this.audioInputDevices.length) {
      this.selectedAudioInput = this.audioInputDevices[0];
    }
    if (this.audioOutputDevices.length) {
      this.selectedAudioOutput = this.audioOutputDevices[0];
    }
    // Update isBlurVideo
    this.isBlurVideo = this.hasBlurVideoFeature;
  }

  selectAudioInput(device: MediaDeviceInfo) {
    this.selectedAudioInput = device;
  }
  selectVideoInput(device: MediaDeviceInfo) {
    this.selectedVideoInput = device;
  }

  selectAudioOutput(device: MediaDeviceInfo) {
    this.selectedAudioInput = device;
  }
  selectVideoQuality(quality: Qualities) {
    this.selectedVideoQuality = quality;
  }

  @Emit()
  showCapabilityStepsDialog() {
    return true;
  }
}
